import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {
  Bank,
  BankConnection,
  BasiqUser,
  BasiqUserService,
} from 'taxtank-core';
import { plainToClass } from 'class-transformer';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * @TODO vik/alex waiting for basiq refactoring
 */
@Component({
  selector: 'app-basiq-connect',
  templateUrl: './basiq-connect.component.html',
  styleUrls: ['./basiq-connect.component.scss'],
  standalone: false
})
export class BasiqConnectComponent extends BaseComponent implements OnInit {
  private basiqUserService = inject(BasiqUserService);

  @Input() bank: Bank;
  @Output() connected: EventEmitter<BankConnection> = new EventEmitter();

  basiqUser: BasiqUser;

  ngOnInit(): void {
    // attach new bank connection to the first user
    this.basiqUserService.getFirst().subscribe(basiqUser => {
      this.basiqUser = basiqUser;
    });
  }

  connect(): void {
    if (this.bank.isManual()) {
      this.connected.emit(plainToClass(BankConnection, { bank: this.bank }));
      return;
    }

    this.basiqUserService.redirectToBasiqConsent(this.bank.externalId, this.basiqUser?.id).subscribe();
  }
}
